<template>
  <svg
    width="46"
    height="46"
    viewBox="0 0 46 46"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      transform="translate(11,11) scale(1)"
      d="M17.03 3H21L14.97 10.14L22.5 21H16.34L11.46 14.59L5.79 21H2L8.36 13.41L1.97 3H8.34L12.78 9.83L17.03 3ZM15.94 19H17.66L8.06 5.15H6.21L15.94 19Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: "SocialTwitter",
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
svg {
  fill: currentColor;
}
</style>
